import { FilterButton } from '../../FilterFields.styles'

const getNextGroupNumber = (composition: string) =>
  parseInt(
    Array.from(composition.matchAll(/\d+/g))
      .flat()
      .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
      .at(-1) || '0',
    10
  ) + 1

type CompositionButtonsProps = {
  composition: string
  handleComposition: (composition: string) => void
  handleCreateGroup: () => void
}

export default function CompositionButtons({
  composition,
  handleComposition,
  handleCreateGroup
}: CompositionButtonsProps) {
  const getOnClickComposition = (operator: 'OR' | 'AND') => () => {
    handleCreateGroup()
    handleComposition(
      `(${composition}) ${operator} ${getNextGroupNumber(composition)}`
    )
  }

  return (
    <div className='d-flex gap-2 flex-grow-1 flex-shrink-0 flex-md-grow-0'>
      <FilterButton
        className='flex-grow-1 flex-md-grow-0 fw-semibold'
        variant='secondary'
        onClick={getOnClickComposition('OR')}
        heightClass='regular'
      >
        Complementar (OU)
      </FilterButton>
      <FilterButton
        className='flex-grow-1 flex-md-grow-0 fw-semibold'
        variant='secondary'
        onClick={getOnClickComposition('AND')}
        heightClass='regular'
      >
        Refinar (E)
      </FilterButton>
    </div>
  )
}
